var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "index-about-section"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_vm._m(0), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "heading-3-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.text1)
    }
  }), _c('div', {
    staticClass: "paragraph-1-large",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.text2)
    }
  })])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo/seu-logo-name-black.svg"),
      "alt": ""
    }
  })]);

}]

export { render, staticRenderFns }